import angular = require("angular");
import data = require("../models/data");
import Contracts = require("../models/contracts");
import {Config} from "../config";

declare var FB: any;

export enum SessionStatus {NOT_LOGGED, LOGGING, LOGGED, LOG_FAILED}
export enum DataStatus {NOT_LOADED, LOADING, LOADED, LOAD_FAILED, DELETED}
export enum EventListType {PUBLIC, PRIVATE, UPCOMING, SUGGESTED, HOSTED, SAVED, PAST};
export enum LoginType {PASSWORD, REFRESH_TOKEN, FACEBOOK, LOCAL_STORAGE};

export class DataModel {

  event: Contracts.EventData;
  eventStatus: DataStatus = DataStatus.NOT_LOADED;

  reservationList: Contracts.ReservationData[];
  reservationListStatus : DataStatus = DataStatus.NOT_LOADED;

  myReservations: Contracts.ReservationData[];
  myReservationsStatus : DataStatus = DataStatus.NOT_LOADED;

  sponsorList: Contracts.SponsorData[];
  sponsorListStatus : DataStatus = DataStatus.NOT_LOADED;

  publicEventList: Contracts.EventData[] = [];
  publicEventListMetadata: Contracts.Metadata;
  publicEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  privateEventList: Contracts.EventData[] = [];
  privateEventListMetadata: Contracts.Metadata;
  privateEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  upcomingEventList: Contracts.EventData[] = [];
  upcomingEventListMetadata: Contracts.Metadata;
  upcomingEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  suggestedEventList: Contracts.EventData[] = [];
  suggestedEventListMetadata: Contracts.Metadata;
  suggestedEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  hostedEventList: Contracts.EventData[] = [];
  hostedEventListMetadata: Contracts.Metadata;
  hostedEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  pastEventList: Contracts.EventData[] = [];
  pastEventListMetadata: Contracts.Metadata;
  pastEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  savedEventList: Contracts.EventData[] = [];
  savedEventListMetadata: Contracts.Metadata;
  savedEventListStatus : DataStatus = DataStatus.NOT_LOADED;

  private http: any;
  private timeout: any;
  private log: any;
  private q: any;
  private spinnerService: any;


  constructor($http, $timeout, $q, $log, spinnerService) {
    this.http = $http;
    this.timeout = $timeout;
    this.log = $log;
    this.q = $q;
    this.spinnerService = spinnerService;
  }

  private setStatus(type: EventListType, status: DataStatus) {
    switch(type) {
      case EventListType.PUBLIC:
        this.publicEventListStatus = status;
        return;
      case EventListType.PRIVATE:
        this.privateEventListStatus = status;
        return;
      case EventListType.UPCOMING:
        this.upcomingEventListStatus = status;
        return;
      case EventListType.HOSTED:
        this.hostedEventListStatus = status;
        return;
      case EventListType.SAVED:
        this.savedEventListStatus = status;
        return;
      case EventListType.PAST:
        this.pastEventListStatus = status;
        return;
      case EventListType.SUGGESTED:
        this.suggestedEventListStatus = status;
        return;
      default:
        throw "Request status change for an unknown type";
    }
  }

  private getStatus(type: EventListType): DataStatus {
    switch(type) {
      case EventListType.PUBLIC:
        return this.publicEventListStatus;
      case EventListType.PRIVATE:
        return this.privateEventListStatus;
      case EventListType.UPCOMING:
        return this.upcomingEventListStatus;
      case EventListType.HOSTED:
        return this.hostedEventListStatus;
      case EventListType.SAVED:
        return this.savedEventListStatus;
      case EventListType.PAST:
        return this.pastEventListStatus;
      case EventListType.SUGGESTED:
        return this.suggestedEventListStatus;
      default:
        throw "Request status for an unknown type";
    }
  }


  private setData(type: EventListType, data: Contracts.EventData[], merge = false, user?) {
    switch(type) {
      case EventListType.PUBLIC:
        if (merge) {
          angular.forEach(data, (item) => {
            this.publicEventList.push(item);
          });
        } else {
          this.publicEventList = data;
        }
        return;
      case EventListType.PRIVATE:
        this.log.debug(merge);
        if (merge) {
          angular.forEach(data, (item) => {
            this.privateEventList.push(item);
          });
          this.log.debug("merge");
          this.log.debug(this.privateEventList);
        } else {
          this.privateEventList = data;
          this.myReservations;
          if (this.myReservations && typeof this.myReservations != "undefined") {
            angular.forEach(this.privateEventList, (value) => {
              angular.forEach(this.myReservations, (value1) => {
                if (value1.event_id == value.id){
                  value1.event_id;
                  value.my_reservation = value1;
                }
              });
              if (value.created_by_profile && value.created_by_profile.id == user.user_id) {
                value.hosted_by_me = true;
              }
            });
          }
          this.privateEventList;
          this.log.debug("not merge");
          this.log.debug(this.privateEventList);
        }
        return;
      case EventListType.UPCOMING:
        if (merge) {
          angular.forEach(data, (item) => {
            this.upcomingEventList.push(item);
          });
        } else {
          this.upcomingEventList = data;
        }
        return;
      case EventListType.HOSTED:
        if (merge) {
          angular.forEach(data, (item) => {
            this.hostedEventList.push(item);
          });
        } else {
          this.hostedEventList = data;
        }
        return;
      case EventListType.SAVED:
        if (merge) {
          angular.forEach(data, (item) => {
            this.savedEventList.push(item);
          });
        } else {
          this.savedEventList = data;
        }
        return;
      case EventListType.PAST:
        if (merge) {
          angular.forEach(data, (item) => {
            this.pastEventList.push(item);
          });
        } else {
          this.pastEventList = data;
        }
        return;
      case EventListType.SUGGESTED:
        if (merge) {
          angular.forEach(data, (item) => {
            this.suggestedEventList.push(item);
          });
        } else {
          this.suggestedEventList = data;
        }
        return;
      default:
        throw "Request data change for an unknown type";
    }
  }

  private setMetadata(type: EventListType, metadata) {
    switch(type) {
      case EventListType.PUBLIC:
        this.publicEventListMetadata = metadata;
        return;
      case EventListType.PRIVATE:
        this.privateEventListMetadata = metadata;
        return;
      case EventListType.UPCOMING:
        this.upcomingEventListMetadata = metadata;
        return;
      case EventListType.HOSTED:
        this.hostedEventListMetadata = metadata;
        return;
      case EventListType.SAVED:
        this.savedEventListMetadata = metadata;
        return;
      case EventListType.PAST:
        this.pastEventListMetadata = metadata;
        return;
      case EventListType.SUGGESTED:
        this.suggestedEventListMetadata = metadata;
        return;
      default:
        throw "Request metadata change for an unknown type";
    }
  }


  private getMetadata(type: EventListType) {
    switch(type) {
      case EventListType.PUBLIC:
        return this.publicEventListMetadata;
      case EventListType.PRIVATE:
        return this.privateEventListMetadata;
      case EventListType.UPCOMING:
        return this.upcomingEventListMetadata;
      case EventListType.HOSTED:
        return this.hostedEventListMetadata;
      case EventListType.SAVED:
        return this.savedEventListMetadata;
      case EventListType.PAST:
        return this.pastEventListMetadata;
      case EventListType.SUGGESTED:
        return this.suggestedEventListMetadata;
      default:
        throw "Request metadata for an unknown type";
    }
  }


  shortenUrl(longUrl) {
    var request = {
      method: "POST",
      url: "https://www.googleapis.com/urlshortener/v1/url?key=" + Config.googleKey,
      data: {
        longUrl
      }
    };

    return this.http(request);
  }

  loadEvents(request, type: EventListType, user) {
    request.method = "GET";

    this.setStatus(type, DataStatus.LOADING);
    this.setData(type, null, false, null);
    this.setMetadata(type, null);

    //this.spinnerService.show("mainSpinner");

    this.log.debug("loadEvents");
    return this.http(request).then(
      (response: Contracts.EventsResponse) => {
        this.log.debug(response);
        this.setData(type, response.data.data, false, user);
        response.data.metadata["request"] = request;
        this.setMetadata(type, response.data.metadata);
        this.setStatus(type, DataStatus.LOADED);
        //this.spinnerService.hide("mainSpinner");
      },
      (error) => {
        this.setData(type, null, false, null);//TODO tmp hack
        this.setMetadata(type, null);//TODO tmp hack
        this.setStatus(type, DataStatus.LOAD_FAILED);
        throw error;
    });
  }

  loadMore(type: EventListType, user?) {

    var metadata = this.getMetadata(type);
    if (metadata && metadata.next_page && !metadata["loadedMore"]) {

      if (!metadata["request"].params) {
        metadata["request"].params = {};
      }

      metadata["request"].params.page = metadata.next_page;
      metadata["loadedMore"] = true;

      this.log.debug("loadMore");
      return this.http(metadata["request"]).then(
        (response: Contracts.EventsResponse) => {
          this.log.debug(response);
          this.setData(type, response.data.data, true, user);
          response.data.metadata["request"] = metadata["request"];
          this.setMetadata(type, response.data.metadata);
          //this.setStatus(type, DataStatus.LOADED);
          return true;
        },
        (error) => {
          this.setData(type, null, false, null);//TODO tmp hack
          this.setMetadata(type, null);//TODO tmp hack
          this.setStatus(type, DataStatus.LOAD_FAILED);
          throw error;
      });
    } else {
      return this.q.when(false);
    }
  }

  loadEvent(request, eventId) {
    request.method = "GET";
    request.url = Config.eventsEndpoint + "/" + eventId;
    //this.event = null;
    this.eventStatus = DataStatus.LOADING;
    return this.http(request).then(
      (response: Contracts.EventResponse) => {
        this.log.debug(response);
        this.event = this.parseEvent(response.data.data);
        this.eventStatus = DataStatus.LOADED;

        return this.event;
      },
      (error) => {
        this.event = null;//TODO tmp hack
        this.eventStatus = DataStatus.LOAD_FAILED;
        throw error;
    });
  }

  deleteEvent(request, eventId) {
    request.method = "DELETE";
    request.url = Config.eventsEndpoint + "/" + eventId;

    this.eventStatus = DataStatus.LOADING;

    return this.http(request).then(
      (response: Contracts.EventResponse) => {
        this.log.debug(response);
      },
      (error) => {
        throw error;
    });
  }

  loadReservations(request, eventId) {
    request.method = "GET";
    request.url = Config.eventsEndpoint + "/" + eventId + "/" + Config.reservations;

    this.reservationListStatus = DataStatus.LOADING;

    return this.http(request).then(
      (response: Contracts.ReservationsResponse) => {
        this.log.debug(response);
        this.reservationListStatus = DataStatus.LOADED;
        return this.reservationList = response.data.data;
      },
      (error) => {
        this.reservationList=null;
        this.reservationListStatus = DataStatus.LOAD_FAILED;
        throw error;
    });
  }

  loadMyReservations(request) {
    request.method = "GET";
    request.url = Config.profileEndpoint + "/" + Config.reservations;

    this.reservationListStatus = DataStatus.LOADING;

    this.http(request).then(
      (response) => {
        this.log.debug(response);
        this.myReservations = response.data.data;
        this.myReservationsStatus = DataStatus.LOADED;
      },
      (error) => {
        this.reservationList=null;
        this.reservationListStatus = DataStatus.LOAD_FAILED;
        throw error;
    });
  }

  loadTimezones(request) {
    request.method = "GET";
    request.url = Config.timezoneEndpoint;

    return this.http(request).then(
      (response) => {
        this.log.debug(response);
        return response.data.data;
      },
      (error) => {
        throw error;
    });
  }

  loadCardsList(request) {
    request.method = "GET";
    request.url = Config.cardsEndpoint;

    return this.http(request).then(
      (response) => {
        this.log.debug(response);
        return response.data.data;
      },
      (error) => {
        throw error;
    });
  }

  loadCard(request,cardId) {
    request.method = "GET";
    request.url = Config.cardsEndpoint + "/" + cardId;

    return this.http(request).then(
      (response) => {
        this.log.debug(response);
        return response.data.data;
      },
      (error) => {
        throw error;
    });
  }

  getCouponData(request,couponNumber) {
    request.method = "GET";
    request.url = Config.couponEndpoint + "/" + couponNumber;

    return this.http(request).then(
      (response) => {
        this.log.debug(response);
        return response.data.data;
      },
      (error) => {
        throw error;
    });
  }

  loadSponsors(request, areaCode) {
    request.method = "GET";
    request.url = Config.areasEndpoint + "/" + areaCode + "/" + Config.sponsors;

    this.sponsorListStatus = DataStatus.LOADING;

    return this.http(request).then(
      (response: Contracts.SponsorsResponse) => {
        this.log.debug(response);
        this.sponsorList = response.data.data;
        this.sponsorListStatus = DataStatus.LOADED;
        return true;
      }).catch(
      (error) => {
        this.sponsorList=null;
        this.sponsorListStatus = DataStatus.LOAD_FAILED;
        throw error;
    });
  }

  deleteReservation(request, eventId) {
    request.method = "DELETE";
    request.url = Config.eventsEndpoint + "/" + eventId + "/" + Config.reservations;

    this.eventStatus = DataStatus.LOADING;

    return this.http(request).then(
      (response: Contracts.EventResponse) => {
        this.log.debug(response);
      },
      (error) => {
        throw error;
    });
  }

  acceptReservation(request, reservationId, message) {
    request.method = "POST";
    request.url = Config.reservationsEndpoint + "/" + reservationId + "/accept";

    request.data = {
      data: {
        message: message
      }
    }

    return this.http(request).then(
      (response: Contracts.EventResponse) => {
        this.log.debug(response);
      },
      (error) => {
        throw error;
    });
  }

  rejectReservation(request, reservationId, message) {
    request.method = "POST";
    request.url = Config.reservationsEndpoint + "/" + reservationId + "/reject";

    request.data = {
      data: {
        message: message
      }
    }

    return this.http(request).then(
      (response: Contracts.EventResponse) => {
        this.log.debug(response);
      },
      (error) => {
        throw error;
    });
  }

  parseEvent(rawEvent) {
    //i will simply parse the notes field as a JSON object
    try {
      rawEvent.notes = JSON.parse(rawEvent.notes);
    } catch (e) {

      rawEvent.notes = {
        version: "1",
        first: [],
        second: [],
        third: []
      }
    }

    return rawEvent;
  }

  loadPublicEvents(request) {
    this.loadEvents(request, EventListType.PUBLIC, null);
  }

  loadMorePublicEvents() {
    return this.loadMore(EventListType.PUBLIC);
  }

  loadPrivateEvents(request, user) {
    this.loadEvents(request, EventListType.PRIVATE, user);
  }

  loadMorePrivateEvents(user) {
    return this.loadMore(EventListType.PRIVATE, user);
  }

  loadUpcomingEvents(request) {
    this.loadEvents(request, EventListType.UPCOMING, null);
  }

  loadMoreUpcomingEvents() {
    return this.loadMore(EventListType.UPCOMING);
  }

  loadHostedEvents(request) {
    this.loadEvents(request, EventListType.HOSTED, null);
  }

  loadMoreHostedEvents() {
    return this.loadMore(EventListType.HOSTED);
  }

  loadSavedEvents(request) {
    this.loadEvents(request, EventListType.SAVED, null);
  }

  loadMoreSavedEvents() {
    return this.loadMore(EventListType.SAVED);
  }

  loadPastEvents(request) {
    this.loadEvents(request, EventListType.PAST, null);
  }

  loadMorePastEvents() {
    return this.loadMore(EventListType.PAST);
  }

  loadSuggestedEvents(request) {
    this.loadEvents(request, EventListType.SUGGESTED, null);
  }

  private isLoadingEvents(type: EventListType) {
    return this.getStatus(type) == DataStatus.LOADING;
  }

  private hasLoadedEvents(type: EventListType) {
    return this.getStatus(type) == DataStatus.LOADED;
  }

  isLoadingPrivateEvents() {
    return this.isLoadingEvents(EventListType.PRIVATE);
  }

  hasLoadedPrivateEvents() {
    return this.hasLoadedEvents(EventListType.PRIVATE);
  }

  isLoadingPublicEvents() {
    return this.isLoadingEvents(EventListType.PUBLIC);
  }

  hasLoadedPublicEvents() {
    return this.hasLoadedEvents(EventListType.PUBLIC);
  }

  isLoadingUpcomingEvents() {
    return this.isLoadingEvents(EventListType.UPCOMING);
  }

  hasLoadedUpcomingEvents() {
    return this.hasLoadedEvents(EventListType.UPCOMING);
  }

  isLoadingHostedEvents() {
    return this.isLoadingEvents(EventListType.HOSTED);
  }

  hasLoadedHostedEvents() {
    return this.hasLoadedEvents(EventListType.HOSTED);
  }

  isLoadingSavedEvents() {
    return this.isLoadingEvents(EventListType.SAVED);
  }

  hasLoadedSavedEvents() {
    return this.hasLoadedEvents(EventListType.SAVED);
  }

  isLoadingSuggestedEvents() {
    return this.isLoadingEvents(EventListType.SUGGESTED);
  }

  hasLoadedSuggestedEvents() {
    return this.hasLoadedEvents(EventListType.SUGGESTED);
  }
}

export class SessionService {

  private data: DataModel;

  private user: data.User;
  private status: SessionStatus;

  private cookies: any;
  private http: any;
  private timeout: any;
  private route: any;
  private rootScope: any;
  private upload: any;
  private log: any;
  private moment;
  private q: any;
  private baseUrl: string;
  spinnerService: any;

  static toDate(dateString: string, clearTimeZone = false): Date {
    if (clearTimeZone) {
      var doo = new Date(dateString);
      return new Date(doo.getTime() + doo.getTimezoneOffset() * 60000);
    } else {

      return new Date(dateString);
    }
  }


  static toPrice(priceString: string): number {
    return parseFloat(priceString) || undefined; //Buu
  }

  /**
    The iso string is already converted to a UTC date so no need to do other than this
  */
  static toISOString(date): string {
    return date ? date.toISOString() : undefined; //Buu
  }

  static toString(localDate: Date): string {
    return localDate ? localDate.toString() : undefined; //Buu
  }

  static after24Hours(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
  }

  static isToday(d: Date): boolean {
    var now = new Date();

    return d.getFullYear() == now.getFullYear() &&
             d.getMonth() == now.getMonth() &&
             d.getDate() == now.getDate();
  }

  static isTomorrow(d: Date): boolean {
    return SessionService.isToday(SessionService.after24Hours(d));
  }

  availableCities: any[];

  static $inject = ["$http", "$timeout", "$rootScope", "$route", "$cookies", "Upload", "moment", "prelogin", "preconfig", "$log", "$q", "spinnerService"];

  constructor($http, $timeout, $rootScope, $route, $cookies, Upload, $moment, prelogin, preconfig, $log, $q, spinnerService) {
    window["SESSION"] = this;
    this.cookies = $cookies;
    this.http = $http;
    this.timeout = $timeout;
    this.route = $route;
    this.rootScope = $rootScope;
    this.upload = Upload;
    this.moment = $moment;
    this.log = $log;
    this.q = $q;
    this.data = new DataModel($http, $timeout, $q, $log, spinnerService);

    this.availableCities = SessionService.parseAvailableCities(preconfig);

    this.user = data.User.createFakeUser(data.UserType.NONE);
    this.status = SessionStatus.NOT_LOGGED;
    this.spinnerService = spinnerService;

    if (!prelogin) {
      this.user = data.User.createFakeUser(data.UserType.NONE);
      this.status = SessionStatus.NOT_LOGGED;
    } else {
      this.user = prelogin.user;
      this.status = prelogin.status;
    }
  }

  prelogin() {

    //Try to refresh the token thus obtaining my data
    //Do not throw but fails silently continuing with normal page load
    return this.loginWithLocalStorage()
      .catch((err) => {
        return this.timeout(false);//empty promise
      });
    }

  preconfig() {
    return this.loadCityList();
  }

  static parseAvailableCities(preconfig) {
    if (!preconfig) {
      return [];
    }

    var result = [];
    var ny;
    var other;

    var allcity = {"id":0,"code":"","url":"","label":"All States","timezone":"","neighborhoods":null,"nourishment":false,"photo":{"id":0,"original":null,"s":null,"m":null,"l":null}};
    result.push(allcity);

    angular.forEach(preconfig, (value) => {
      if (value.code == "OTHER" || value.code == "OT") {
        other = value;
      } /*else if (value.code == "NY") {
        ny = value;
      }*/ else {
        result.push(value);
      }
    });

    /*if (ny) {
      if (Config.isOnward) {
        result.push(ny);
      } else {
        result.unshift(ny);
      }
    }*/

    if (Config.isOnward) {
      result.sort();
    }

    if (other) {
      result.push(other);
    }

    return result;
  }

  /**
    Promise to acquire a token for the session

    For pwd login auth0 is username and auth1 is pwd,
    For facebook login auth0 is userId and auth1 is fbToken
    For tokenRefresh login auth0 is the refresh token and auth1 is unused

    loginType can be one of "password", "facebook" or "refreshToken"
  */
  private obtainToken(auth0: string, auth1: string, loginType: LoginType) {

    var url;
    var message;

    switch(loginType) {
      case LoginType.LOCAL_STORAGE:

        var localStorageTokenType = localStorage.getItem(Config.localStorageTokenType);
        var localStorageAccessToken = localStorage.getItem(Config.localStorageToken);
        var localStorageRefreshToken = localStorage.getItem(Config.localStorageRefreshToken);

        if (!localStorageTokenType || !localStorageAccessToken || !localStorageRefreshToken) {
          return this.q.reject("Cannot obtain token from localStorage");
        }

        return this.q.when({
          token_type: localStorageTokenType,
          access_token: localStorageAccessToken,
          refresh_token: localStorageRefreshToken
        });

      case LoginType.FACEBOOK:

        url = Config.tokenSocialEndpoint;
        message = {
            "grant_type": "social",
            "social_provider": "facebook",
            "social_uid": auth0,
            "social_token": auth1
        };

        break;
      case LoginType.REFRESH_TOKEN:

        url = Config.tokenEndpoint;
        message = {
          grant_type: "refresh_token",
          refresh_token: auth0
        };

        break;
      default: //LoginType.PASSWORD

        url = Config.tokenEndpoint;
        message = {
          "grant_type": "password",
          "username": auth0,
          "password": auth1
        };
    }

    this.log.debug(message);

    return this.http({
      method: "POST",
      url: url,
      data: message
    }).then((tokenResponse) => {
      var tokenData: Contracts.TokenResponse = tokenResponse.data;
      this.log.debug(tokenData);
      return tokenData;
    });
  }


  private buildBaseRequest(tokenData?: Contracts.TokenResponse) {
    var token = !!tokenData ?
      data.User.buildToken(tokenData):
      this.user.token;
    /*
    var td:any = tokenData || {
      token_type: localStorage.getItem(Config.localStorageTokenType),
      access_token: localStorage.getItem(Config.localStorageToken),
      refresh_token: localStorage.getItem(Config.localStorageRefreshToken)
    }

    //TODO remove field from user now is useless
    this.user.token = localStorage.getItem(Config.localStorageToken);

    var token = data.User.buildToken(td);
    */
    return {
      headers: {Authorization: token}
    };
  }

  private loadProfile(tokenData?) {
    var request: any = this.buildBaseRequest(tokenData);
    request.method = "GET";
    request.url = Config.profileEndpoint;

    return this.http(request).then((profileResponse) => {
      this.log.debug(profileResponse);
      return [tokenData, profileResponse];
    });
  }

  loginWithFb(userId, token) {
    return this.login(userId, token, LoginType.FACEBOOK);
  }

  loginWithRefreshToken(refreshToken) {
    return this.login(refreshToken, null, LoginType.REFRESH_TOKEN);
  }

  loginWithPassword(username, password) {
        //try {
            return this.login(username, password, LoginType.PASSWORD);
        //} catch (e) {
        //    alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        //}

  }

  loginWithLocalStorage() {
    return this.login(null, null, LoginType.LOCAL_STORAGE);
  }

  private login(auth0: string, auth1: string, loginType: LoginType) {
    this.log.debug("login has been called");

    if (loginType != LoginType.REFRESH_TOKEN) {//this check is to avoid flash of things when trying to refresh the token in background
      this.status = SessionStatus.LOGGING;
    }

    return this.obtainToken(auth0, auth1, loginType)
      .then((tokenData) => {return this.loadProfile(tokenData)})
      .then((result) => {
          var tokenData = result[0];
          var profileData = result[1].data;

          this.user = data.User.createUser(tokenData, profileData);

          if (loginType != LoginType.LOCAL_STORAGE) {//this check is fundamental as it avoids overriding new data with old storage one
            //check for localStorage errors
            try {
              localStorage.setItem(Config.localStorageTokenType, tokenData.token_type);
              localStorage.setItem(Config.localStorageRefreshToken, tokenData.refresh_token);
              localStorage.setItem(Config.localStorageToken, tokenData.access_token);
            } catch (error) {
              this.log.debug("Local Storege Error");
            }
          }

          if (!(this.status == SessionStatus.LOGGED)) {//fundamental too to avoid broadcasting while aleady logged
            this.status = SessionStatus.LOGGED;
            this.rootScope.$broadcast("session.login");
          }


          return {
            user: this.user,
            status: this.status
          }

      })
      .catch((err) => {
        this.log.debug("Caught");
        this.log.debug("login error: "+err);
        this.status = SessionStatus.LOG_FAILED;
        this.user = null;

        throw err;
      });
  }


  logout() {
    this.log.debug("logout has been called");
    localStorage.removeItem(Config.localStorageRefreshToken);
    localStorage.removeItem(Config.localStorageToken);
    localStorage.removeItem(Config.localStorageTokenType);

    this.status = SessionStatus.NOT_LOGGED;
    this.user = data.User.createFakeUser(data.UserType.NONE);
    this.data = new DataModel(this.http, this.timeout, this.q, this.log, this.spinnerService);

    FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
            FB.logout(function(response) {

            });
        }
    });

    this.rootScope.$broadcast("session.logout");
  }

  loadHostedEvents() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.dashboardEventsEndpoint + '?only=hosted';

    this.data.loadHostedEvents(request);
  }

  loadMoreHostedEvents() {
    return this.data.loadMoreHostedEvents();
  }


  loadUpcomingEvents() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.dashboardEventsEndpoint + '?only=reserved';

    this.data.loadUpcomingEvents(request);
  }

  loadMoreUpcomingEvents() {
    return this.data.loadMoreUpcomingEvents();
  }


  loadSavedEvents() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.dashboardEventsEndpoint + '?only=draft';

    this.data.loadSavedEvents(request);
  }


  loadMoreSavedEvents() {
    return this.data.loadMoreSavedEvents();
  }


  loadPastEvents() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.dashboardEventsEndpoint + '?only=past';

    this.data.loadPastEvents(request);
  }


  loadMorePastEvents() {
    return this.data.loadMorePastEvents();
  }

  loadNourishment(eventId) {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.eventsEndpoint + '/' + eventId + '/nourishments';

    return this.http(request).then((response) => {
      this.log.debug(response);
      return response;
    });
  }

  sponsorFilter(sponsors) {
    var amount;
    var result = [];
    angular.forEach(sponsors, (sponsor) => {
        amount = sponsor.currentValue;
        var parts = {"sponsor_id" : sponsor.id,"amount" : Math.round(sponsor.currentValue * 100)};
        if(amount){
              result.push(parts);
        }
    });
    return result;
  }

  saveNourishment(eventId, supposedGuests,  sponsors) {
    var request: any = this.buildBaseRequest();
    var sponsorsData = this.sponsorFilter(sponsors);
    request.method = "PUT";
    request.url = Config.eventsEndpoint + '/' + eventId;
    request.data = {
      data: {
        expected_guests: supposedGuests,
        sponsorships: sponsorsData
      }
    };
    return this.http(request).then((response) => {
      this.log.debug(response);
      return response;
    });
  }

  saveExpectedGuest(eventId, supposedGuests) {
    var request: any = this.buildBaseRequest();
    request.method = "PUT";
    request.url = Config.eventsEndpoint + '/' + eventId;
    request.data = {
      data: {
        expected_guests: supposedGuests
      }
    };
    return this.http(request).then((response) => {
      this.log.debug(response);
      return response;
    });
  }

  getLandingPage(): string {
    return Config.home;
  }

  /**
    The session has a login call in action
  */
  isLogging(): boolean {
    return this.status == SessionStatus.LOGGING;
  }

  /**
    The session is not logged and is not trying to login
  */
  isNotLogging(): boolean {
    return this.status == SessionStatus.NOT_LOGGED || this.status == SessionStatus.LOG_FAILED;
  }

  /**
    The session is successfully logged
  */

  isOnward(): boolean {
    if (Config.isOnward) {
      return true;
    }
  }

  isLogged(): boolean {
    return this.status == SessionStatus.LOGGED;
  }

  getType(): data.UserType {
    return this.user.type;
  }

  isGuest(): boolean {
    return this.user.type == data.UserType.GUEST;
  }

  isHost(): boolean {
    return this.user.type == data.UserType.HOST;
  }

  isHostRequested(): boolean {
    return this.user.hostRequested;
  }

  getStatus(): SessionStatus {
    return this.status;
  }

  getUserId(): number {
    return this.user.user_id;
  }

  getFirstName(): string {
    return this.user.firstName;
  }

  getLastName(): string {
    return this.user.lastName;
  }

  getFullName(): string {
    return this.user.firstName + " " + this.user.lastName;
  }

  getBirthDate(): Date {
    return this.user.birthDate;
  }

  getAvatar(): string {
    return this.user.avatar;
  }

  getAddress(): string {
    return this.user.address;
  }

  getAddressSecondary(): string {
    return this.user.address_secondary;
  }

  getLocation(): string {
    return this.user.location;
  }

  getCity(): string {
    return this.user.city;
  }

  getCityState(): string {
    return this.user.city_state;
  }

  getPhone(): string {
    return this.user.phone;
  }

  getBio(): string {
    return this.user.bio;
  }

  getEmail(): string {
    return this.user.email;
  }

  getData(): DataModel {
    return this.data;
  }

  getLocalNow(): Date {
    return new Date();
  }

  loadPublicEvents(rawFilter?) {
    this.data.loadPublicEvents(this.buildLoadEventsRequest(rawFilter));
  }

  loadMorePublicEvents() {
    return this.data.loadMorePublicEvents();
  }

  loadPrivateEvents(user,rawFilter?) {
    this.data.loadPrivateEvents(this.buildLoadEventsRequest(rawFilter),this.user);
  }

  loadMorePrivateEvents() {
    return this.data.loadMorePrivateEvents(this.user);
  }

  deleteEvent(eventId) {
    return this.data.deleteEvent(this.buildBaseRequest(), eventId);
  }

  deleteReservation(eventId) {
    return this.data.deleteReservation(this.buildBaseRequest(), eventId);
  }

  acceptReservation(reservationId, message) {
    return this.data.acceptReservation(this.buildBaseRequest(), reservationId, message);
  }

  rejectReservation(reservationId, message) {
    return this.data.rejectReservation(this.buildBaseRequest(), reservationId, message);
  }

  getAvailableCities() {
    return this.availableCities;
  }

  getCardList() {
    if (this.isLogged()) {
      return this.data.loadCardsList(this.buildBaseRequest());
    }
  }

  getCardSelected(cardId) {
    if (this.isLogged()) {
      return this.data.loadCard(this.buildBaseRequest(),cardId);
    }
  }

  couponValidation(couponNumber) {
    if (this.isLogged()) {
      return this.data.getCouponData(this.buildBaseRequest(),couponNumber);
    }
  }

  formatDate(date) {
    var dateFormatted;
    if (date) {
      dateFormatted = date;
      var year = dateFormatted.getFullYear();
      var month = dateFormatted.getMonth()+1;
      if (month.toString().length == 1) {
        month  = "0" + month;
      }
      var day = dateFormatted.getDate();
      if (day.toString().length == 1) {
        day  = "0" + day;
      }
      dateFormatted = year+"-"+month+"-"+day;
    }
    return dateFormatted;
  }

  formatTime(time) {
    var timeFormatted;
    if (time) {
      timeFormatted = time;
      var hours = timeFormatted.getHours();
      var minutes = timeFormatted.getMinutes();
      if (hours.toString().length == 1) {
        hours  = "0" + hours;
      }
      if (minutes.toString().length == 1) {
        minutes  = "0" + minutes;
      }
      timeFormatted = hours+":"+minutes;
    }
    return timeFormatted;
  }

  private buildLoadEventsRequest(rawFilter?) {

    var request: any = this.buildBaseRequest();
    request.url = Config.eventsEndpoint;

    if (rawFilter) {

      var queryString;
      if (rawFilter.queryString && rawFilter.queryString.length > 0) {

        var tmp = rawFilter.queryString.trim();
        if (tmp.length > 0) {
          queryString = tmp;
        }
      }

      var cost;
      var rawCostType: data.CostType = rawFilter.costType;

      switch (rawCostType) {
        case data.CostType.FREE:
          cost = 'free';
          break;
        case data.CostType.PAID:
          cost = 'paid';
          break;
      }

      var eventType;
      var rawEventType: data.EventType = rawFilter.eventType;

      //TODO check this
      switch (rawEventType) {
        case data.EventType.PUBLIC:
          eventType = 'public';
          break;
        case data.EventType.PRIVATE:
          eventType = 'private';
          break;
        case data.EventType.MANUAL:
          eventType = 'manual_approval';
          break;
      }

      var alcoholTypes;

      if (rawFilter.alcoholTypes && rawFilter.alcoholTypes.length > 0) {

        alcoholTypes = "";

        if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.HOST_PROVIDES) >= 0) {
          alcoholTypes +='host_provides,';
        }
        if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.BYOB) >= 0) {
          alcoholTypes +='byob,';
        }
        if (rawFilter.alcoholTypes.indexOf(data.AlcoholType.ALCOHOL_FREE) >= 0) {
          alcoholTypes +='alcohol_free,';
        }

        alcoholTypes = alcoholTypes.substring(0, alcoholTypes.length - 1);
      }


      var dietTypes;

      if (rawFilter.dietTypes && rawFilter.dietTypes.length > 0) {

        dietTypes = "";

        if (rawFilter.dietTypes.indexOf(data.DietType.VEGETARIAN) >= 0) {
          dietTypes +='vegetarian,';
        }

        if (rawFilter.dietTypes.indexOf(data.DietType.VEGAN) >= 0) {
          dietTypes +='vegan,';
        }

        if (rawFilter.dietTypes.indexOf(data.DietType.GLUTEN_FREE) >= 0) {
          dietTypes +='gluten_free,';
        }

        if (rawFilter.dietTypes.indexOf(data.DietType.KOSHER) >= 0) {
          dietTypes +='kosher,';
        }

        dietTypes = dietTypes.substring(0, dietTypes.length - 1);
      }

      var city;
      if (rawFilter.city && rawFilter.city.length > 0) {
        city = rawFilter.city;
      }

      var dateMin;
      if (rawFilter.minDate) {
        dateMin = rawFilter.minDate;
        var year = dateMin.getFullYear();
        var month = dateMin.getMonth()+1;
        if (month.toString().length == 1) {
          month  = "0" + month;
        }
        var day = dateMin.getDate();
        if (day.toString().length == 1) {
          day  = "0" + day;
        }
        dateMin = year+"-"+month+"-"+day;
      }

      var dateMax;
      if (rawFilter.maxDate) {
        dateMax = rawFilter.maxDate;
        var year = dateMax.getFullYear();
        var month = dateMax.getMonth()+1;
        if (month.toString().length == 1) {
          month  = "0" + month;
        }
        var day = dateMax.getDate();
        if (day.toString().length == 1) {
          day  = "0" + day;
        }
        dateMax = year+"-"+month+"-"+day;
      }

      request.params = {
        q: queryString,
        event_type: eventType,
        date_from: dateMin,
        date_to: dateMax,
        //date_from: rawFilter.minDate,
        //date_to: rawFilter.maxDate,
        cost: cost,
        area_code: city,
        alcohol_policy: alcoholTypes,
        dietary_restrictions: dietTypes
      };
    }

    return request;
  }

  loadSuggestedEvents() {
    var request: any = this.buildBaseRequest();
    request.url = Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + Config.suggested;

    this.data.loadSuggestedEvents(request);
  }

  loadEvent(eventId?: number) {
      if (typeof eventId === 'undefined') { //beware empty check here!
        eventId = this.data.event.uuid;
      }

      return this.data.loadEvent(this.buildBaseRequest(), eventId);
  }

  /**
    Reservation for free dinners
  */
  reserve(reservationDraft) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + Config.reservations;

    var data = {
      data: {
          additional_guests : reservationDraft
      }
    }

    request.data = data;

    return this.http(request).then(() => {
      this.loadMyReservations();
    });
  }

  /**
    reservation for paid dinners
  */
  pay(data, qty, reservationDraft,couponId) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.eventsEndpoint + "/" + this.data.event.uuid + "/" + Config.reservations;

    data.qty = qty;

    if (couponId == "") {
      request.data = {
        data: {
          additional_guests : reservationDraft,
          payment: data
        }
      };
    } else {
      request.data = {
        data: {
          additional_guests : reservationDraft,
          payment: data,
          coupon_id: couponId
        }
      };
    }

    return this.http(request);
  }

  registerNewCard(data) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.cardsEndpoint;

    request.data = {
      data: {
        stripe_token : data.stripe_token,
        favourite: data.favourite
      }
    };

    return this.http(request);
  }

  changeCard(data,param) {
    var request: any = this.buildBaseRequest();
    if (param === "delete" ) {
      request.method = "DELETE";
      request.url = Config.cardsEndpoint + "/" + data.id;

    } else {
      request.method = "PATCH";
      request.url = Config.cardsEndpoint + "/" + data.id;

      request.data = {
        data: {
          favourite: data.favourite
        }
      };
    }

    return this.http(request);
  }

  loadReservations(eventId: number) {
      return this.data.loadReservations(this.buildBaseRequest(), eventId);
  }

  loadMyReservations() {
    if (this.isLogged()) {
      this.data.loadMyReservations(this.buildBaseRequest());
    }
  }

  loadTimezones() {
    if (this.isLogged()) {
      return this.data.loadTimezones(this.buildBaseRequest());
    }
  }

  loadSponsors(areaCode) {
    if (this.isLogged()) {
      return this.data.loadSponsors(this.buildBaseRequest(), areaCode);
    }
  }

  createEvent(eventDraft) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.eventsEndpoint;

    var when = this.computeEventDateAndDuration(eventDraft.begin, eventDraft.begin, eventDraft.end);
    this.log.debug(when);
    //var eventPhotos = eventDraft.image ? [eventDraft.image] : [];

    var newEventType;

    if(eventDraft.eventType == data.EventType.PUBLIC) {
      newEventType = "public";
    } else if(eventDraft.eventType == data.EventType.PRIVATE) {
      newEventType = "private";
    } else if(eventDraft.eventType == data.EventType.MANUAL) {
      newEventType = "manual_approval";
    }

    var timezoneOther;
    if (eventDraft.timezone !== undefined){
      timezoneOther = eventDraft.timezone.label;
    } else {
      timezoneOther = null;
    }

    var newData /*: Contracts.EventRequest*/ = {
      data: {
        full_address: eventDraft.full_address,
        secondary_address: eventDraft.secondary_address,
        title: eventDraft.name,
        description: eventDraft.description,
        pets_allowed: true,
        //event_datetime: when.date,
        event_date: when.newDate,
        event_time: when.newTime,
        duration: when.duration,
        alcohol_policy: eventDraft.alcoholType,
        meal_type: eventDraft.mealType,
        dietary_restrictions: eventDraft.dietTypes,
        notes: JSON.stringify(eventDraft.notes),
        event_type: newEventType,
        number_of_guests_min: eventDraft.minGuestCount,
        number_of_guests_max: eventDraft.maxseats,
        price_per_person: SessionService.toPrice(eventDraft.price) * 100,
        cover: eventDraft.coverUpdate,
        //event_photos: eventDraft.photos,
        area_code: eventDraft.area.city && eventDraft.area.city.code,
        area_other: eventDraft.area_other,
        neighborhood: eventDraft.area.neighborhood && eventDraft.area.neighborhood.code,
        timezone: eventDraft.area.city.timezone,
        timezone_other: timezoneOther,
        parent_auth: eventDraft.parentAuth
      }
    }

    request.data = newData;

    return this.http(request);
  }

  updateEvent(eventDraft, eventId) {
    var request: any = this.buildBaseRequest();
    request.method = "PUT";
    request.url = Config.eventsEndpoint + "/" + eventId;

    var when = this.computeEventDateAndDuration(eventDraft.begin, eventDraft.begin, eventDraft.end);
    this.log.debug(when);
    //var eventPhotos = eventDraft.image ? [eventDraft.image] : [];

    var newEventType;

    if(eventDraft.eventType == data.EventType.PUBLIC) {
      newEventType = "public";
    } else if(eventDraft.eventType == data.EventType.PRIVATE) {
      newEventType = "private";
    } else if(eventDraft.eventType == data.EventType.MANUAL) {
      newEventType = "manual_approval";
    }

    var newData /*: Contracts.EventRequest*/ = {
      data: {
        full_address: eventDraft.full_address,
        secondary_address: eventDraft.secondary_address,
        title: eventDraft.name,
        description: eventDraft.description,
        pets_allowed: true,
        //event_datetime: when.date,
        event_date: when.newDate,
        event_time: when.newTime,
        event_type: newEventType, // !!!!!! CAN OVERRIDE EVENT TYPE ????
        duration: when.duration,
        alcohol_policy: eventDraft.alcoholType,
        meal_type: eventDraft.mealType,
        dietary_restrictions: eventDraft.dietTypes,
        notes: JSON.stringify(eventDraft.notes),
        type_of_event: "dinner",//eventDraft.eventType,
        number_of_guests_min: eventDraft.minGuestCount,
        //number_of_guests_max: eventDraft.maxGuestCount,
        number_of_guests_max: eventDraft.maxseats,
        visible: true,
        private: true,
        price_per_person: SessionService.toPrice(eventDraft.price) * 100,
        cover: eventDraft.coverUpdate,
        //event_photos: eventDraft.photos,
        area_code: eventDraft.area.city && eventDraft.area.city.code,
        area_other: eventDraft.area_other,
        neighborhood: eventDraft.area.neighborhood && eventDraft.area.neighborhood.code,
        timezone: eventDraft.area.city.timezone,
        timezone_other: eventDraft.timezone.label
      }
    }

    request.data = newData;

    return this.http(request);
  }

  publishEvent(eventId) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    //request.url = Config.eventsEndpoint + "/" + eventId + "/publish";
    request.url = Config.eventsEndpoint + "/" + eventId + "/submit";

    return this.http(request);
  }

  computeEventDateAndDuration(date: Date, begin: Date, end: Date) {

    begin.setFullYear(date.getFullYear());
    begin.setDate(date.getDate());
    begin.setMonth(date.getMonth());

    end.setFullYear(date.getFullYear());
    end.setDate(date.getDate());
    end.setMonth(date.getMonth());

    if (end.getTime() < begin.getTime()) {
      end.setDate(end.getDate() + 1);
    }

    var resultDate = begin;

    var resultDuration = end.getTime() - begin.getTime();
    var resultDuration = Math.floor(resultDuration / 1000);

    return {
      date: SessionService.toISOString(resultDate),
      newDate:this.formatDate(resultDate),
      //newDate: resultDate.getFullYear() + "-" + (resultDate.getMonth() + 1) + "-" + resultDate.getDate(),
      newTime: this.formatTime(resultDate),
      //newTime: begin.getHours() + ":" + begin.getMinutes(),
      duration: resultDuration
    }
  }

  updateProfile(profileDraft) {
    var request: any = this.buildBaseRequest();
    request.method = "PUT";
    request.url = Config.profileEndpoint;

    var dob = profileDraft.birthDate;
    var dateString;

    if (dob) {
      dateString = this.moment(dob).format('YYYY-MM-DD');
    }

    var data: Contracts.ProfileRequest = {
      data: {
        first_name: profileDraft.firstName,
        last_name: profileDraft.lastName,
        city: profileDraft.city,
        city_state: profileDraft.city_state,
        dob: dateString,
        email: profileDraft.email,
        avatar: profileDraft.avatar,
        address: profileDraft.address,
        phone: profileDraft.phone,
        bio: profileDraft.bio
      }
    }

    request.data = data;

    return this.http(request).then(()=> {return this.refreshProfile();});
  }

  refreshProfile() {
    return this.loadProfile().then((tokenAndProfile) => {
      var profile = tokenAndProfile[1].data;
      this.user.refreshProfile(profile);
      //nothing to return?
      return true;
    });
  }


  signup(newDataDraft) {
    this.log.debug("signup has been called");

    var request = {
      method: "POST",
      url: Config.usersEndpoint,
      data: {
        first_name: newDataDraft.firstName,
        last_name: newDataDraft.lastName,
        email: newDataDraft.newEmail,
        phone: newDataDraft.cellPhone,
        high_school: newDataDraft.highSchoolSelected,
        gender: newDataDraft.genderSelected,
        zip_code: newDataDraft.zipCode,
        bbyo_member: newDataDraft.bbyoMemberSelected,
        parent_first_name: newDataDraft.parentFirstName,
        parent_last_name: newDataDraft.parentLastName,
        parent_email: newDataDraft.parentNewEmail,
        parent_phone: newDataDraft.parentCellPhone,
        password: newDataDraft.newPassword,
        password_confirmation: newDataDraft.newPassword
      }
    };

    return this.http(request);
  }


  getS3Credentials() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.newUploadEndpoint + "?success_action_redirect=%23";
    return this.http(request);
  }


  /**
    Will directly return the new url of the uploaded file
  */
  uploadFile(file, progressListener?) {

    //this.upload.base64DataUrl(file).then((a)=> {
    //});

    return this.getS3Credentials().then((response)=> {
      var s3Credentials = response.data;

      return this.uploadToS3(s3Credentials, file, progressListener).then((response) => {
        this.log.debug(response.data);
        var m = response.data.match( /<Location>(.+?)<\/Location>/ );
        if ( m && m[1]) {
          this.log.debug(m[1]);
          return m[1];
        } else {
          throw "S3 Upload error";
        }
      });
    });
  }


  private uploadToS3(s3Credentials, file, progressListener?) {
    //TODO resolve url in a better way

    return this.upload.upload({
      url: "https://" + s3Credentials.s3.bucket + ".s3.amazonaws.com/",
      method: 'POST',
      data: {
          // utf8: "✓",
          key: s3Credentials.s3.key,
          AWSAccessKeyId: s3Credentials.s3.aws_access_key_id,
          acl: s3Credentials.s3.acl,
          policy: s3Credentials.s3.policy,
          signature: s3Credentials.s3.signature,
          success_action_status: s3Credentials.s3.success_action_status,
          file: file
        }
      }).then(
        null,
        (error) => {
          this.log.debug('Error status: ' + error.status);
        },
        (evt) => {
          var progressPercentage = (evt.loaded / evt.total);
          if(progressListener) {
            progressListener(evt);
          }
        }
      );
  }

  resetPassword(email: string) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.resetPasswordEndpoint;
    request.data = {
      email: email
    }
    return this.http(request);
  }

  changePasswordByToken(rawData) {

    var request: any = this.buildBaseRequest();
    request.method = "PUT";
    request.url = Config.resetPasswordEndpoint;
    request.data = {
      password: rawData.password,
      password_confirmation: rawData.password,
      reset_password_token: rawData.resetPasswordToken
    }

    return this.http(request);
  }

  changePassword(rawData) {
    var request: any = this.buildBaseRequest();
    request.method = "PUT";
    request.url = Config.updatePasswordEndpoint;
    request.data = {
      data: {
        password: rawData.password,
        password_confirmation: rawData.password_confirmation,
      }
    }
    return this.http(request);
  }

  shortenUrl(url) {
    return this.data.shortenUrl(url);
  }

  sendInvitations(messageType, emails, text) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.eventsEndpoint + '/' + this.data.event.uuid + '/invitations';
    request.data = {
      data: {
        emails: emails,
        text: text,
        message_type: messageType
      }
    }

    return this.http(request);
  }

  sendMessageToHost(emails, text) {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.eventsEndpoint + '/' + this.data.event.uuid + '/hostmessage';
    request.data = {
      data: {
        emails: emails,
        text: text,
      }
    }

    return this.http(request);
  }

  public requestHost() {
    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.hostRequestEndpoint;

    return this.http(request);
  }


  public autoPromoteToHost() {

    var request: any = this.buildBaseRequest();
    request.method = "POST";
    request.url = Config.hostRequestEndpoint;
    request.data = {
      force: 1
    }
    return this.http(request)
      .then((response) => {
        return this.loginWithLocalStorage();
      });
  }

  //TODO
  loadCityList() {
    var request: any = this.buildBaseRequest();
    request.method = "GET";
    request.url = Config.areasEndpoint;
    return this.http(request).then((response) => { return response.data.data;});
  }


}



/** WEBPACK FOOTER **
 ** ./src/scripts/services/session.ts
 **/